<template>
  <section class="custom-wrapper">
    <div class="row">
      <div class="col-md-12">
        <p>Supply any informative "hints" for the user to offer assistance with the inspection of this category.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <z-textarea v-model="hints" :rows="4" name="hints" label="Hints" @keyup="changed" />
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZTextarea from '@/components/utilities/elements/TextArea.vue'
export default {
  name: 'MatrixHints',
  components: {
    ZTextarea
  },
  props: {
    value: Object
  },
  emits: ['changed'],
  computed: {
    ...mapState(adasmatrixStore, ['adasmatrix']),
    hints: {
      get() {
        let _data = ''
        if (this.adasmatrix !== undefined && this.adasmatrix !== null) {
          _data = this.adasmatrix.hints
        }
        return _data
      },
      set(value) {
        this.setData({
          name: 'hints',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['setData']),
    changed() {
      this.$emit('changed')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
}
</style>
